import { useMemo, useState } from 'react';
import OrderCard from './OrderCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faStore, faPhone, faLocationDot, faUpRightAndDownLeftFromCenter, faObjectUngroup, faBox, faArrowUpRightFromSquare, faSquareShareNodes } from '@fortawesome/free-solid-svg-icons';
import helmetIcon from '../assets/img/capacete-desenho.png';
import '../assets/scss/grouping-card.scss';
import Conversor from '../../../../helper/Conversor';
import { status_colors, status_map } from '../utils/map';
import formatarData from '../utils/formatarDate';
import OrderGroupingService from '../../../../services/OrderGroupingService';
import Swal from 'sweetalert2';
import { Tooltip } from '@mui/material';

export default function OrderGroupingCard({ grouping, handleShowModal, handleGroupOrder, groupingReadyToPickup }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const orderGroupingService = useMemo(() => new OrderGroupingService(), []);

    async function ungroupOrders(groupingCode) {
        const result = await Swal.fire({
            title: 'Deseja desafezer o agrupamento?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#17a2b8',
            confirmButtonText: 'Sim, desfazer!',
            cancelButtonText: 'Voltar',
        });

        if (result.isConfirmed) {
            setIsModalOpen(false);
            handleShowModal(null);
            const response = await orderGroupingService.ungroupOrders(groupingCode);
            if (response.ok) {
                Swal.fire({
                    title: 'Agrupamento desfeito com sucesso!',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
                return response;
            } else {
                Swal.fire({
                    title: 'Ocorreu um erro ao desfazer o agrupamento!',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                })
            }
        }
    }

    async function setPendingGroup(groupingCode, driverId) {
        const result = await Swal.fire({
            title: 'Deseja solicitar um novo entregador?',
            text: 'O entregador atual será desvinculado e o pedido aguardará um novo entregador!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#17a2b8',
            confirmButtonText: 'Sim, solicitar!',
            cancelButtonText: 'Voltar',
        });

        if (result.isConfirmed) {
            setIsModalOpen(false);
            handleShowModal(null);
            const response = await orderGroupingService.setPendingGroup(groupingCode, driverId);
            if (response.ok) {
                Swal.fire({
                    title: 'Entrega cancelada com sucesso!',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });
                return response;
            } else {
                Swal.fire({
                    title: 'Ocorreu um erro ao cancelar a entrega!',
                    icon: 'error',
                    timer: 1500,
                    showConfirmButton: false,
                })
            }
        }
    }

    const toggleModal = (e) => {
        e.stopPropagation();
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            <div className="order-grouping-card" onClick={toggleModal} key={grouping._id}>
                <div className="grouping-header">
                    <FontAwesomeIcon icon={faLayerGroup} color='#004B66' />
                    <span style={{ marginLeft: 8 }}>Agrupamento de {grouping.orders.length} pedidos</span>
                    {grouping.orders.filter((order) => order.orderDetails.shared).length > 0 &&
                        <Tooltip style={{ marginLeft: 'auto' }} title="Esse agrupamento possui entregas compartilhadas" arrow>
                            <span style={{ marginLeft: 'auto' }}>
                                <FontAwesomeIcon icon={faSquareShareNodes} style={{ height: 24 }} color="#0d6efd" />
                            </span>
                        </Tooltip>
                    }
                    {(grouping.deliveryman && grouping.deliveryman.trackingLink) &&
                        <a className='tracking-link' style={{ marginLeft: 'auto' }} alt="Rastrear pedido" href={grouping.deliveryman.trackingLink} target="_blank" rel="noreferrer" onClick={(event) => { event.stopPropagation(); }}><FontAwesomeIcon icon={faArrowUpRightFromSquare} color='#000' /></a>}
                    <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} style={{ marginLeft: 'auto' }} />
                </div>
                <div className="grouping-body">
                    {grouping.stores.map((store) => (
                        <div className="order-store" style={{ marginBottom: 10 }}>
                            <div className="order-store-icon">
                                <FontAwesomeIcon icon={faStore} />
                            </div>
                            <div className="order-store-content">
                                <div className="order-store-name">{store.companyName}</div>
                            </div>
                        </div>
                    ))}
                    {(grouping.deliveryman && grouping.deliveryman.id) &&
                        <div className="driver-info">
                            <div className="driver-icon">
                                <img src={helmetIcon} alt="Ícone de capacete" />
                            </div>
                            <div className="driver-content">
                                <div className="driver-name">{grouping.deliveryman.name}</div>
                                <div className="driver-phone"><FontAwesomeIcon icon={faPhone} /> {Conversor.converterFormatoTelefone(String(grouping.deliveryman.cellNumber))}</div>
                            </div>
                        </div>
                    }
                    {grouping.orders.map((order) =>
                        <div className="delivery-at">
                            <div className="delivery-at-icon">
                                <FontAwesomeIcon icon={faLocationDot} />
                            </div>
                            <div className="delivery-at-content">
                                {(order.orderDetails.status !== "unconfirmed" && order.orderDetails.status !== "canceled") && <div className="delivery-at-customer"> {order.requester.name} - #{order.orderDetails.deliveryCode}</div>}
                                <div className="delivery-at-address">{order.requester.address.street}, nº{order.requester.address.number} - {order.requester.address.neighborhood}, {order.requester.address.city} - {order.requester.address.state}</div>
                            </div>
                        </div>)
                    }
                </div>
                <div className="grouping-footer">
                    <div className="grouping-status-container">
                        <div className="grouping-status">
                            <div className="status-point" style={{ backgroundColor: status_colors[grouping.status] }}></div>
                            <span>{status_map[grouping.status]}</span>
                        </div>
                        <div className="grouping-date">{formatarData(grouping.createdAt)}</div>
                    </div>

                    {(
                        (grouping.status === "PENDING" || grouping.status === "ACCEPT" || grouping.status === "ARRIVED")
                        && !grouping.isAvailableForDelivery
                    ) &&
                        <button className="order-card-button" onClick={(event) => { event.stopPropagation(); groupingReadyToPickup(grouping._id); }}>Pedidos prontos</button>
                    }
                </div>
            </div>
            {isModalOpen && (
                <div className="group-modal-backdrop" onClick={toggleModal}>
                    <div className="group-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="group-title">Agrupamento de {grouping.orders.length} pedidos</div>
                        <div className="group-subtitle">Clique na entrega para ver detalhes</div>
                        {grouping.orders.map(order => (
                            <OrderCard
                                key={order._id}
                                order={order}
                                handleShowModal={handleShowModal}
                                handleGroupOrder={handleGroupOrder}
                                showGroupCheck={false}
                            />
                        ))}
                        <div className="group-actions">
                            {(grouping.deliveryman && grouping.status !== "DELIVERED" && grouping.status !== "CANCELED") && <button type="button" className="cancel-grouping-button" onClick={() => setPendingGroup(grouping.groupingCode, grouping.deliveryman.id)}><FontAwesomeIcon icon={faBox} style={{ height: 14, marginRight: 10 }} />Solicitar outro entregador</button>}
                            <button type="button" className="cancel-grouping-button" onClick={() => ungroupOrders(grouping.groupingCode)}><FontAwesomeIcon icon={faObjectUngroup} style={{ height: 14, marginRight: 10 }} />Desfazer agrupamento</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
